import { Injectable } from '@angular/core';
import * as contracts from '../contract/email';
import { GetEmailByIdRequest, GetEmailByIdResponse } from '../contract/email';
import { response as emailListResponse } from './email-list.response';
import { Observable, of } from 'rxjs';
import { EmailMapper } from '../mappers/email-mapper';
import { delay } from 'rxjs/operators';

@Injectable()
export class EmailMockService implements contracts.IEmailService {
  getEmailList(request: contracts.GetEmailListRequest): Observable<contracts.GetEmailListResponse> {
    const svcJsonResp = emailListResponse;
    const response = new contracts.GetEmailListResponse();
    response.entities = svcJsonResp.data.findEmailNotifications.map(
      EmailMapper.Instance().emailDtoToEmail
    );
    return of(response).pipe(delay(500));
  }

  getEmailBody(request: contracts.GetEmailBodyRequest): Observable<contracts.GetEmailBodyResponse> {
    const response = new contracts.GetEmailBodyResponse();
    return of(response).pipe(delay(500));
  }

  getEmailById(request: GetEmailByIdRequest): Observable<GetEmailByIdResponse> {
    const response = new contracts.GetEmailByIdResponse();
    return of(response).pipe(delay(500));
  }
}
